module.exports = __webpack_public_path__ + "assets/img/381309be9710ee84810698a63aaba777.svg";